import dayjs, { extend } from "dayjs";
import utc from "dayjs/plugin/utc";

extend(utc);

// ÐÑÐµÐ¼Ñ Ð´Ð¸Ð»ÐµÑÐ° â ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½: Ñ 1 Ð¼Ð°ÑÑÐ° 2024 ÐµÐ´Ð¸Ð½ÑÐ¹ Ð¿Ð¾ÑÑ UTC+5, Ð¿ÐµÑÐµÐ²Ð¾Ð´Ð° ÑÐ°ÑÐ¾Ð² Ð½ÐµÑ.
//
// Ð Ð°Ð½ÑÑÐµ Ð·Ð´ÐµÑÑ Ð±ÑÐ»Ð° Ð·Ð¾Ð½Ð° Â«Asia/AlmatyÂ» ÑÐµÑÐµÐ· dayjs/plugin/timezone. Ð¡Ð¼ÐµÑÐµÐ½Ð¸Ðµ
// Ð´Ð»Ñ Ð½ÐµÑ Ð±ÐµÑÑÑÑÑ Ð¸Ð· tz-Ð±Ð°Ð·Ñ ÑÑÐµÐ´Ñ, Ð° Ð½Ðµ Ð¸Ð· ÐºÐ¾Ð´Ð°: Ñ node 14 Ð½Ð° ÑÐµÑÑ-ÑÐµÑÐ²ÐµÑÐµ
// (tz 2021a) Ð¸ Ð½Ð° ÑÐ°Ð½Ð½ÐµÑÐµ CI ÐÐ»Ð¼Ð°ÑÑ ÐµÑÑ GMT+6, Ð¸ Ð²ÑÐµÐ¼Ñ Ð·Ð°Ð¿Ð¸ÑÐ¸ ÑÐµÐ·Ð¶Ð°Ð»Ð¾ Ð½Ð° ÑÐ°Ñ â
// 05:30 Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»Ð¾ÑÑ ÐºÐ°Ðº 06:30, ÑÐµÑÑÑ recordDate Ð¿Ð°Ð´Ð°Ð»Ð¸. Ð¤Ð¸ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð½Ð¾Ðµ
// ÑÐ¼ÐµÑÐµÐ½Ð¸Ðµ ÑÑÐ¸ÑÐ°ÐµÑÑÑ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²Ð¾ Ð² Ð»ÑÐ±Ð¾Ð¼ Ð±ÑÐ°ÑÐ·ÐµÑÐµ Ð¸ Ð½Ð° Ð»ÑÐ±Ð¾Ð¼ node.
const DEALER_UTC_OFFSET_MINUTES = 5 * 60;

function fixDateTimezone(date, utcOffsetMinutes = DEALER_UTC_OFFSET_MINUTES) {
  return dayjs(date).utc().utcOffset(utcOffsetMinutes);
}

export default fixDateTimezone;
